<template slot-scope="{ isActive }">
  <div
    ref="modalFooter"
    class="room-upgrade-modal-footer"
  >
    <div class="room-upgrade-modal-footer-left">
      <div class="room-upgrade-modal-footer-price">
        <span class="total">{{ tc('booking.total') }}</span>
        <span class="value">{{ formatPrice(currentCartTotal) }}</span>
      </div>
      <button
        class="left-cta--large"
        :class="{'loading': roomUpgradeLoading, 'upgrade-selected': roomUpgradeSelected}"
        @click.stop.prevent="handleLeftCtaClick"
        @keydown.enter.stop.prevent="handleLeftCtaClick"
      >
        {{ roomUpgradeSelected ? tc('booking.removeUpgrade') : tc('booking.continueLabel') }}
        <div
          class="sr-only"
          role="status"
        >
          {{ roomUpgradeLoading ? tc('accessibility.loadingButtonStatus') : '' }}
        </div>
      </button>
    </div>
    <div class="room-upgrade-modal-footer-right">
      <div class="room-upgrade-modal-footer-price">
        <span class="total">{{ tc('booking.total') }}</span>
        <span class="value">{{ formatPrice(upgradeRoomCartTotal) }}</span>
      </div>
      <button
        class="right-cta--large"
        :class="{'loading': roomUpgradeLoading, 'upgrade-selected': roomUpgradeSelected}"
        @click.stop.prevent="handleRightCtaClick"
      >
        {{ roomUpgradeSelected ? tc('booking.continueLabel') : tc('booking.upgrade') }}
        <div
          class="sr-only"
          role="status"
        >
          {{ roomUpgradeLoading ? tc('accessibility.loadingButtonStatus') : '' }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'RoomUpgradeModalFooter',
    computed: {
      ...mapState('cart', ['cart', 'roomUpgradeSelected', 'roomUpgradeLoading', 'roomUpgradeTotal', 'previousCartItem', 'roomUpgradeAvailable']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('currency', ['getDisplayPrice']),
      ...mapGetters('booking', ['getBookingTrackingV2', 'getQuery']),
      currentCartTotal() {
        return this.previousCartItem?.total
      },
      upgradeRoomCartTotal() {
        return this.roomUpgradeTotal
      },
    },
    methods: {
      ...mapActions('cart', ['applyRoomUpgrade', 'removeRoomUpgrade']),
      closeModal() {
        this.$emit('close')
        document.body.classList.remove('no-scroll')
      },
      formatPrice(price) {
        return this.getDisplayPrice({ price, withIsoCode: true, isoAfter: true })
      },
      handleLeftCtaClick() {
        if (this.roomUpgradeSelected) {
          this.removeRoomUpgrade().then(() => {
            this.$track(this.getBookingTrackingV2(this.getQuery, { event: 'upgradeRemoved', upgradeName: `${this.cart.lines[0].sitecoreContent.room.title} - ${this.cart.lines[0].sitecoreContent.bed.title}` }))
          })
        } else {
          this.closeModal()
        }
      },
      async handleRightCtaClick() {
        if (this.roomUpgradeSelected) {
          this.closeModal()
        } else {
          this.applyRoomUpgrade().then(() => {
            this.$track(this.getBookingTrackingV2(this.getQuery, { event: 'step8', upgradeName: `${this.roomUpgradeAvailable.title} - ${this.roomUpgradeAvailable.bedType[0].title}` }))
          })
        }
      }
    }
  }
</script>
